import axiosBackEnd from "../../config/axios/axios-back-end";
import { apiStart, apiFail, apiComplete } from "./api";
import { message } from "antd";
import { orderBy } from "lodash";

export const hmgmainGetHmgMain = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackEnd.get("/api/hmg-main", null, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      dispatch(apiComplete());
      if (!result.data.error) {
        const dataset = orderBy(result.data.data, [
          (hmgmain) => hmgmain.hmg_name.toLowerCase(),
        ]);
        dataset.forEach((el) => {
          el.projects = orderBy(el.projects, [
            (project) => project.project_name.toLowerCase(),
          ]);
        });
        return dataset;
      }
      return [];
    } catch (error) {
      dispatch(apiComplete());
      message.error("Internal Server Error");
      return [];
    }
  };
};
//BEGIN HMG ROLE MAPPING FUNCTIONS
/**
 * retrieve hmg_id
 * @param string hmg_id
 * @author iresha
 * @date 2022-01-07
 */
export const rolesGetMappedtoHMG = (hmg_id, loading = true) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get(
        `/api/hmg-main/role-mapping?hmg_id=${hmg_id}`,
        null,
        { headers: headers },
      );
      if (loading) {
        dispatch(apiComplete());
      }
      if (!response.data.error) {
        return response.data.data;
      } else {
        message.error(response.data.message);
        dispatch(apiFail());
        return [];
      }
    } catch (err) {
      message.error(err.message);
      dispatch(apiComplete());
      return [];
    }
  };
};

//UPDATE HMG ROLE MAPPING
/**
 * @param string hmg_id
 * @param array role_ids
 * @author iresha
 * @date 2022-01-07
 */
export const hmgRoleUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        `/api/hmg-main/update-allocated-roles`,
        data,
        { headers: headers },
      );
      dispatch(apiComplete());
      if (response.data.error) {
        //  message.error(response.data.errors.join(", "));
        return {
          error: true,
          message: response.data.errors.join(", "),
          data: response.data.data,
        };
      } else {
        message.success(response.data.message);
        dispatch(apiFail());
        return {
          error: false,
        };
      }
    } catch (err) {
      message.error(err.message);
      dispatch(apiComplete());
      return {
        error: true,
        message: err.message,
      };
    }
  };
};
